var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLqfirspeak3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(6211 1953.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_7",
    "data-name": "Union 7",
    transform: "translate(-15845 -6575.155)",
    fill: "rgba(255,255,255,0.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9686.5,4622a52.5,52.5,0,1,1-52.5,52.5A52.5,52.5,0,0,1,9686.5,4622Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9686.5 4626 C 9679.951171875 4626 9673.599609375 4627.28173828125 9667.623046875 4629.8095703125 C 9661.84765625 4632.25244140625 9656.6611328125 4635.75 9652.205078125 4640.205078125 C 9647.75 4644.66064453125 9644.251953125 4649.84765625 9641.8095703125 4655.62255859375 C 9639.2822265625 4661.599609375 9638 4667.95068359375 9638 4674.5 C 9638 4681.04931640625 9639.2822265625 4687.400390625 9641.8095703125 4693.37744140625 C 9644.251953125 4699.15234375 9647.75 4704.33935546875 9652.205078125 4708.794921875 C 9656.6611328125 4713.25 9661.84765625 4716.74755859375 9667.623046875 4719.1904296875 C 9673.599609375 4721.71826171875 9679.951171875 4723 9686.5 4723 C 9693.048828125 4723 9699.400390625 4721.71826171875 9705.376953125 4719.1904296875 C 9711.15234375 4716.74755859375 9716.3388671875 4713.25 9720.794921875 4708.794921875 C 9725.25 4704.33935546875 9728.748046875 4699.15234375 9731.1904296875 4693.37744140625 C 9733.7177734375 4687.400390625 9735 4681.04931640625 9735 4674.5 C 9735 4667.95068359375 9733.7177734375 4661.599609375 9731.1904296875 4655.62255859375 C 9728.748046875 4649.84765625 9725.25 4644.66064453125 9720.794921875 4640.205078125 C 9716.3388671875 4635.75 9711.15234375 4632.25244140625 9705.376953125 4629.8095703125 C 9699.400390625 4627.28173828125 9693.048828125 4626 9686.5 4626 M 9686.5 4622 C 9715.4951171875 4622 9739 4645.5048828125 9739 4674.5 C 9739 4703.4951171875 9715.4951171875 4727 9686.5 4727 C 9657.5048828125 4727 9634 4703.4951171875 9634 4674.5 C 9634 4645.5048828125 9657.5048828125 4622 9686.5 4622 Z",
    stroke: "none",
    fill: "rgba(255,255,255,0.06)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(-6186.542 -1927.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M22.833,2a3.842,3.842,0,0,0-2.676,1.634c-.511.541-1.237,1.321-2.108,2.288-1.738,1.931-4.062,4.62-6.392,7.638a74.733,74.733,0,0,0-6.5,9.727C3.4,26.54,2,30.063,2,33.25a20.833,20.833,0,0,0,41.667,0c0-3.187-1.4-6.71-3.162-9.963a74.741,74.741,0,0,0-6.5-9.727c-2.33-3.018-4.654-5.707-6.392-7.638-.87-.967-1.6-1.748-2.108-2.288A3.834,3.834,0,0,0,22.833,2Zm-.913,7.406c.327-.363.633-.7.913-1,.28.3.586.64.913,1,1.68,1.867,3.914,4.452,6.141,7.337a69.624,69.624,0,0,1,6.038,9.023c1.658,3.062,2.534,5.637,2.534,7.484a15.625,15.625,0,1,1-31.25,0c0-1.847.877-4.421,2.534-7.484a69.63,69.63,0,0,1,6.037-9.023c2.227-2.885,4.461-5.47,6.141-7.337Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M16,9.813a7.813,7.813,0,1,1,7.813,7.813A7.812,7.812,0,0,1,16,9.813Zm7.813-2.6a2.6,2.6,0,1,0,2.6,2.6A2.6,2.6,0,0,0,23.813,7.208Z",
    transform: "translate(22.459 0)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLqfirspeak3);
export default __webpack_public_path__ + "static/media/lqfirspeak-3.f2326a2a5e602ce35714695a51806915.svg";
export { ForwardRef as ReactComponent };